import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const Audience = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <style type="text/css">
          {`
      #mc_embed_signup {
        background: white;
        width: 100%;
        max-width: 600px;
        margin: auto;
      }
    `}
        </style>
      </Helmet>

      <Header />
      <div className="max-w-2xl mx-auto p-6">
        <div id="mc_embed_signup">
          <form
            action="https://adhish.us17.list-manage.com/subscribe/post?u=ec650527643b8d8b3533eaffe&amp;id=04e0cc676d&amp;f_id=0049c2e1f0"
            method="post"
            target="_blank"
            className="space-y-4"
          >
            <h2 className="text-2xl font-bold mb-4 text-center">Subscribe</h2>
            <p className="text-sm text-gray-600 text-center">Get updates straight to your inbox</p>

            <div>
              <label htmlFor="mce-EMAIL" className="block text-sm font-medium text-gray-700">
                Email Address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                id="mce-EMAIL"
                required
                className="mt-1 block w-full rounded-lg border border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 p-2"
              />
            </div>

            <div>
              <label htmlFor="mce-FNAME" className="block text-sm font-medium text-gray-700">
                First Name
              </label>
              <input
                type="text"
                name="FNAME"
                id="mce-FNAME"
                className="mt-1 block w-full rounded-lg border border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 p-2"
              />
            </div>

            <div>
              <label htmlFor="mce-LNAME" className="block text-sm font-medium text-gray-700">
                Last Name
              </label>
              <input
                type="text"
                name="LNAME"
                id="mce-LNAME"
                className="mt-1 block w-full rounded-lg border border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 p-2"
              />
            </div>

            <div style={{ display: "none" }} aria-hidden="true">
              <input
                type="text"
                name="b_ec650527643b8d8b3533eaffe_04e0cc676d"
                tabIndex="-1"
                defaultValue=""
              />
            </div>

            <div className="pt-4">
              <input
                type="submit"
                value="Subscribe"
                name="subscribe"
                id="mc-embedded-subscribe"
                className="w-full bg-indigo-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-indigo-700 transition"
              />
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Audience;
